import React, { useState, useEffect } from 'react';
import { db } from '../LoginComp/firebase';
import { collection, query, where, getDocs, orderBy, limit, startAfter, getCountFromServer } from 'firebase/firestore';

import './journal.css';

function EBooks() {
  // State management
  const [ebook, setEbook] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [lastVisible, setLastVisible] = useState(null);

  // Fetch Journal Articles from Firestore -
  const fetchEbooks = async (page) => {
    try {
      const pageSize = 6; // Number of items per page
      const ebookRef = collection(db, 'mainresources');
      let q = query(
        ebookRef,
        where('resourceType', '==', 'E-book'),
        orderBy('created_at'),
        limit(pageSize)
      );

      if (page > 1 && lastVisible) {
        q = query(
          ebookRef,
          where('resourceType', '==', 'E-book'),
          orderBy('created_at'),
          startAfter(lastVisible),
          limit(pageSize)
        );
      }

      const querySnapshot = await getDocs(q);
      const ebooks = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));

      setEbook(ebooks);
      setLastVisible(querySnapshot.docs[querySnapshot.docs.length - 1]);

      // Calculate total pages using count query
      const countSnapshot = await getCountFromServer(query(ebookRef, where('resourceType', '==', 'E-book')));
      const totalPages = Math.ceil(countSnapshot.data().count / pageSize);
      setTotalPages(totalPages);

    } catch (error) {
      console.error("Error fetching journal articles:", error);
    }
  };

  // Handle pagination click
  const paginate = (page) => {
    setCurrentPage(page);
    fetchEbooks(page);
  };

  useEffect(() => {
    fetchEbooks(currentPage);
  }, [currentPage]);

return (
  <div className="journal-page-container">

    {/* HERO SECTION */}
    <section className="hero">

      <div className="hero-image">
        <img
          src="/imgbook.png"
          alt="Books and Research"
        />
      </div>

      <div className="hero-content">

        <h1>Eye Care Digital Library</h1>

        <p>
          Your gateway to advanced research,
          clinical references, educational
          publications, and professional
          ophthalmic learning resources.
        </p>

      </div>

    </section>

    {/* PAGE HEADER */}
    <div className="journal-heading-section">

      <h2>E-Books Collection</h2>

      <p>
        Explore curated ophthalmology and
        optometry e-books including academic
        references, patient education materials,
        clinical guides, and advanced eye care
        resources for students and professionals.
      </p>

    </div>

    {/* BOOK GRID */}
    <div className="articles-container">

      {ebook.length > 0 ? (

        ebook.map((book) => (

          <div
            key={book.id}
            className="article-item"
          >

            {/* COVER IMAGE */}
            {book.coverImageURL && (
              <img
                src={book.coverImageURL}
                alt={book.title}
                className="book-cover-image"
              />
            )}

            {/* CONTENT */}
            <div className="article-content">

              {/* TITLE */}
              <h4>{book.title}</h4>

              {/* META DATA */}
              <div className="book-meta-data">

                {book.author && (
                  <p>
                    <strong>Author:</strong>{" "}
                    {book.author}
                  </p>
                )}

                {book.publication_year && (
                  <p>
                    <strong>Year:</strong>{" "}
                    {book.publication_year}
                  </p>
                )}

                {book.isbn && (
                  <p>
                    <strong>ISBN:</strong>{" "}
                    {book.isbn}
                  </p>
                )}

              </div>

              {/* DESCRIPTION */}
              {book.description && (
                <p className="book-description">
                  {book.description}
                </p>
              )}

              {/* BUTTON */}
              {book.pdfFileURL && (
                <a
                  href={book.pdfFileURL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="read-article-btn"
                >
                  Read E-Book
                </a>
              )}

            </div>

          </div>

        ))

      ) : (

        <div className="no-books-found">

          <h3>No E-Books Available</h3>

          <p>
            No digital resources or ophthalmic
            e-books have been uploaded yet.
          </p>

        </div>

      )}

    </div>

    {/* PAGINATION */}
    {totalPages > 1 && (

      <div className="pagination-container">

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage - 1)
          }
          disabled={currentPage === 1}
        >
          Previous
        </button>

        {Array.from(
          { length: totalPages },
          (_, index) => (

            <button
              key={index + 1}
              className={`pagination-button ${
                currentPage === index + 1
                  ? 'active'
                  : ''
              }`}
              onClick={() =>
                paginate(index + 1)
              }
            >
              {index + 1}
            </button>

          )
        )}

        <button
          className="pagination-button"
          onClick={() =>
            paginate(currentPage + 1)
          }
          disabled={
            currentPage === totalPages
          }
        >
          Next
        </button>

      </div>

    )}

  </div>
);
}


export default EBooks